export const UPDATE_SCRIBE = 'UPDATE_SCRIBE';
export const UPDATE_SCRIBE_FAILED = 'UPDATE_SCRIBE_FAILED';
export const UPDATE_SCRIBE_SUCCESS = 'UPDATE_SCRIBE_SUCCESS';
export const SET_ACTIVE_SCRIBE = 'SET_ACTIVE_SCRIBE';
export const SET_ACTIVE_ELEMENTS = 'SET_ACTIVE_ELEMENTS';
export const ADD_TO_ACTIVE_ELEMENTS = 'ADD_TO_ACTIVE_ELEMENTS';
export const SET_SHOW_ELEMENT_MODAL = 'SET_SHOW_ELEMENT_MODAL';
export const ADD_SCRIBE_REQUESTED = 'ADD_SCRIBE_REQUESTED';
export const ADD_SCRIBE_SUCCESS = 'ADD_SCRIBE_SUCCESS';
export const CREATE_ELEMENT = 'CREATE_ELEMENT';
export const CREATE_TEXT_ELEMENT = 'CREATE_TEXT_ELEMENT';
export const CREATE_SHAPE_ELEMENT = 'CREATE_SHAPE_ELEMENT';
export const CREATE_IMAGE_ELEMENT = 'CREATE_IMAGE_ELEMENT';
export const DELETE_ELEMENT_BY_ID = 'DELETE_ELEMENT_BY_ID';
export const MOVE_ELEMENT_ON_TIMELINE = 'MOVE_ELEMENT_ON_TIMELINE';
export const DELETE_ACTIVE_ELEMENT = 'DELETE_ACTIVE_ELEMENT';
export const LOAD_SCRIBES = 'LOAD_SCRIBES';
export const LOAD_SCRIBES_SUCCESS = 'LOAD_SCRIBES_SUCCESS';
export const DELETE_SCRIBE = 'DELETE_SCRIBE';
export const DELETE_SCRIBE_SUCCESS = 'DELETE_SCRIBE_SUCCESS';
export const SORT_SCRIBES = 'SORT_SCRIBES';
export const DELETE_MULTIPLE_ELEMENTS_BY_ID = 'DELETE_MULTIPLE_ELEMENT_BY_ID';
export const SAVE_AUDIO = 'SAVE_AUDIO';
export const SAVE_AUDIO_SUCCESS = 'SAVE_AUDIO_SUCCESS';
export const SAVE_AUDIO_FAILED = 'SAVE_AUDIO_FAILED';
export const DELETE_AUDIO = 'DELETE_AUDIO';
export const UPDATE_AUDIO_CONFIG = 'UPDATE_AUDIO_CONFIG';
export const LOAD_SCRIBE_BY_ID = 'LOAD_SCRIBE_BY_ID';
export const LOAD_CURSORS = 'LOAD_CURSORS';
export const LOAD_CURSORS_SUCCESS = 'LOAD_CURSORS_SUCCESS';
export const UPDATE_SCRIBE_CURSOR = 'UPDATE_SCRIBE_CURSOR';
export const LOCK_ELEMENTS = 'LOCK_ELEMENTS';
export const UNLOCK_ELEMENTS = 'UNLOCK_ELEMENTS';
export const LOCK_ACTIVE_ELEMENTS = 'LOCK_ACTIVE_ELEMENTS';
export const UNLOCK_ACTIVE_ELEMENTS = 'UNLOCK_ACTIVE_ELEMENTS';
export const TOGGLE_GRID = 'TOGGLE_GRID';
export const UPDATE_SCRIBE_TITLE = 'UPDATE_SCRIBE_TITLE';
export const SET_ELEMENTS_TIMINGS = 'SET_ELEMENTS_TIMINGS';
export const PREP_SCRIBE_FOR_EDITOR_SUCCESS = 'PREP_SCRIBE_FOR_EDITOR_SUCCESS';
export const EDITOR_CLOSE = 'EDITOR_CLOSE';
export const UPDATE_SCENE_ELEMENTS = 'UPDATE_SCENE_ELEMENTS';
export const UPDATE_SCENE_THUMBNAIL = 'UPDATE_SCENE_THUMBNAIL';
export const SET_SELECTED_SCENES = 'SET_SELECTED_SCENES';
export const SET_ACTIVE_SCENE = 'SET_ACTIVE_SCENE';
export const CREATE_SCENE = 'CREATE_SCENE';
export const DUPLICATE_SELECTED_SCENES = 'DUPLICATE_SELECTED_SCENES';
export const DELETE_SELECTED_SCENES = 'DELETE_SELECTED_SCENES';
export const UPDATE_SCENE = 'UPDATE_SCENE';
export const CHANGE_SCENE_ORDER = 'CHANGE_SCENE_ORDER';
export const UPDATE_CLIPBOARD_PAYLOAD = 'UPDATE_CLIPBOARD_PAYLOAD';
export const UPLOAD_LIBRARY_IMAGE_ASSET = 'UPLOAD_LIBRARY_IMAGE_ASSET';
export const UPLOAD_IMAGE_ASSET_ON_LOAD = 'UPLOAD_IMAGE_ASSET_ON_LOAD';
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS';
export const UPLOAD_IMAGE_FAILED = 'UPLOAD_IMAGE_FAILED';
export const UPLOAD_USER_IMAGE_ASSET = 'UPLOAD_USER_IMAGE_ASSET';
export const REWRITE_HISTORY = 'REWRITE_HISTORY';

export const updateScribe = (scribe, skipUndoHistory = false) => ({
  type: UPDATE_SCRIBE,
  scribe,
  skipUndoHistory
});

export const updateScribeFailed = (error, scribe) => ({
  type: UPDATE_SCRIBE_FAILED,
  scribe,
  error
});

export const updateScribeSuccess = scribe => ({
  type: UPDATE_SCRIBE_SUCCESS,
  scribe
});

export const setActiveScribe = scribeId => ({
  type: SET_ACTIVE_SCRIBE,
  scribeId
});

export const setActiveElements = (elementIds = []) => ({
  type: SET_ACTIVE_ELEMENTS,
  elementIds
});

export const addToActiveElements = elementId => ({
  type: ADD_TO_ACTIVE_ELEMENTS,
  elementId
});

export const setShowElementModal = (elementType, elementId, scribeId) => ({
  type: SET_SHOW_ELEMENT_MODAL,
  elementType,
  elementId,
  scribeId
});

export const addScribe = ({
  title,
  canvasSize,
  templateId = null,
  replaceHistory = false,
  source,
  elements,
  thumbnail,
  settings,
  cursor,
  scenes,
  audioClips
}) => ({
  type: ADD_SCRIBE_REQUESTED,
  title,
  date: new Date(),
  canvasSize,
  templateId,
  replaceHistory,
  source,
  elements,
  thumbnail,
  settings,
  cursor,
  scenes,
  audioClips
});

export const addScribeSuccess = scribe => ({
  type: ADD_SCRIBE_SUCCESS,
  scribe
});

export const createElement = (element, scribeId, canvasSize) => ({
  type: CREATE_ELEMENT,
  element,
  scribeId,
  canvasSize
});

export const createShapeElement = (shapeType, scribeId, canvasSize) => ({
  type: CREATE_SHAPE_ELEMENT,
  shapeType,
  scribeId,
  canvasSize
});

export const createImageElement = (scribeId, canvasSize, initialData) => ({
  type: CREATE_IMAGE_ELEMENT,
  scribeId,
  canvasSize,
  initialData
});

export const deleteElementById = (elementId, scribeId) => ({
  type: DELETE_ELEMENT_BY_ID,
  elementId,
  scribeId
});

export const deleteMultipleElementsById = (elements, scribeId) => ({
  type: DELETE_MULTIPLE_ELEMENTS_BY_ID,
  elements,
  scribeId
});

export const moveElementOnTimeline = (scribeId, source, destination, draggableId) => ({
  type: MOVE_ELEMENT_ON_TIMELINE,
  scribeId,
  source,
  destination,
  draggableId
});

export const deleteActiveElement = scribeId => ({
  type: DELETE_ACTIVE_ELEMENT,
  scribeId
});

export const loadScribes = (query = '') => ({
  type: LOAD_SCRIBES,
  query
});

export const loadScribesSuccess = scribes => ({
  type: LOAD_SCRIBES_SUCCESS,
  scribes
});

export const deleteScribe = scribe => ({
  type: DELETE_SCRIBE,
  scribe
});

export const deleteScribeSuccess = (scribeId, title) => ({
  type: DELETE_SCRIBE_SUCCESS,
  scribeId,
  title
});

export const sortScribes = sortOrder => ({
  type: SORT_SCRIBES,
  sortOrder
});

export const deleteAudio = (scribeId, audioType, duration) => ({
  type: DELETE_AUDIO,
  scribeId,
  audioType,
  duration
});

export const updateAudioConfig = (scribeId, audioType, config) => ({
  type: UPDATE_AUDIO_CONFIG,
  scribeId,
  audioType,
  config
});

export const saveAudio = ({ audio, scribeId, source, trackLength, audioType, volume = 1, fileName }) => ({
  type: SAVE_AUDIO,
  audio,
  scribeId,
  source,
  trackLength,
  audioType,
  volume,
  fileName
});

export const saveAudioSuccess = audioType => ({
  type: SAVE_AUDIO_SUCCESS,
  audioType
});

export const saveAudioFailed = audioType => ({
  type: SAVE_AUDIO_FAILED,
  audioType
});

export const loadScribeById = (scribeId, setToActiveOnLoad) => ({
  type: LOAD_SCRIBE_BY_ID,
  scribeId,
  setToActiveOnLoad
});

export const createTextElement = (scribeId, canvasSize) => ({
  type: CREATE_TEXT_ELEMENT,
  scribeId,
  canvasSize
});

export const loadCursors = () => ({
  type: LOAD_CURSORS
});

export const loadCursorsSuccess = cursors => ({
  type: LOAD_CURSORS_SUCCESS,
  cursors
});

export const updateScribeCursor = (scribeId, cursorId) => ({
  type: UPDATE_SCRIBE_CURSOR,
  scribeId,
  cursorId
});

export const lockElements = (elementIds, scribeId, eventTrigger) => ({
  type: LOCK_ELEMENTS,
  elementIds,
  scribeId,
  eventTrigger
});

export const unlockElements = (elementIds, scribeId, eventTrigger) => ({
  type: UNLOCK_ELEMENTS,
  elementIds,
  scribeId,
  eventTrigger
});

export const lockActiveElements = (scribeId, eventTrigger) => ({
  type: LOCK_ACTIVE_ELEMENTS,
  scribeId,
  eventTrigger
});

export const unlockActiveElements = (scribeId, eventTrigger) => ({
  type: UNLOCK_ACTIVE_ELEMENTS,
  scribeId,
  eventTrigger
});

export const toggleGrid = scribeId => ({
  type: TOGGLE_GRID,
  scribeId
});

export const updateScribeTitle = (title, scribeId) => ({
  type: UPDATE_SCRIBE_TITLE,
  title,
  scribeId
});

export const setElementsTimings = ({ scribeId, elementIds, property, value }) => ({
  type: SET_ELEMENTS_TIMINGS,
  scribeId,
  elementIds,
  property,
  value
});

export const prepScribeForEditorSuccess = scribe => ({ type: PREP_SCRIBE_FOR_EDITOR_SUCCESS, scribe });
export const editorClose = () => ({ type: EDITOR_CLOSE });

export const updateSceneElements = (elements, thumbnail, scribeId, sceneId) => ({
  type: UPDATE_SCENE_ELEMENTS,
  elements,
  thumbnail,
  scribeId,
  sceneId
});

export const updateSceneThumbnail = (thumbnail, scribeId) => ({ type: UPDATE_SCENE_THUMBNAIL, thumbnail, scribeId });

export const createScene = (scribeId, eventTrigger) => ({
  type: CREATE_SCENE,
  scribeId,
  eventTrigger
});

export const setSelectedScenes = (sceneIds = []) => ({
  type: SET_SELECTED_SCENES,
  sceneIds
});

export const setActiveScene = (scribeId, sceneId) => ({
  type: SET_ACTIVE_SCENE,
  scribeId,
  sceneId
});

export const duplicateScenes = (scribeId, eventTrigger) => ({
  type: DUPLICATE_SELECTED_SCENES,
  scribeId,
  eventTrigger
});

export const deleteSelectedScenes = (scribeId, eventTrigger) => ({
  type: DELETE_SELECTED_SCENES,
  scribeId,
  eventTrigger
});

export const updateScene = (scene, scribeId) => ({
  type: UPDATE_SCENE,
  scene,
  scribeId
});

export const changeSceneOrder = (scribeId, source, destination, draggableId) => ({
  type: CHANGE_SCENE_ORDER,
  scribeId,
  source,
  destination,
  draggableId
});

export const updateClipboardPayload = payload => ({
  type: UPDATE_CLIPBOARD_PAYLOAD,
  payload
});

export const uploadLibraryImageAsset = (file, filename, scribeId, originalAssetId) => ({
  type: UPLOAD_LIBRARY_IMAGE_ASSET,
  file,
  filename,
  scribeId,
  originalAssetId
});

export const uploadImageAssetOnLoad = (libraryElements, scribeId) => ({
  type: UPLOAD_IMAGE_ASSET_ON_LOAD,
  libraryElements,
  scribeId
});

export const uploadImageAssetSuccess = () => ({
  type: UPLOAD_IMAGE_SUCCESS
});

export const uploadImageAssetFailed = () => ({
  type: UPLOAD_IMAGE_FAILED
});

export const uploadUserImageAsset = (file, filename, scribeId, originalAssetId) => ({
  type: UPLOAD_USER_IMAGE_ASSET,
  file,
  filename,
  scribeId,
  originalAssetId
});

export const updateUndoRedoHistory = (activeScribePast, activeScribeFuture) => ({
  type: REWRITE_HISTORY,
  activeScribePast,
  activeScribeFuture
});
